import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";
import EmptyState from "@/components/base/EmptyState";

interface MovieSectionProps {
  title: string;
  description?: string;
  movies: Movie[];
  moreTo: string;
  moreLabel?: string;
  titleId?: string;
}

export default function MovieSection({
  title,
  description,
  movies,
  moreTo,
  moreLabel = "查看更多",
  titleId,
}: MovieSectionProps) {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-10 md:pt-14">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-primary-500" />
          <div>
            <h2
              id={titleId}
              className="font-heading text-xl md:text-2xl font-black text-foreground-950"
            >
              {title}
            </h2>
            {description ? (
              <p className="mt-1 text-sm text-foreground-500">{description}</p>
            ) : null}
          </div>
        </div>
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      </div>

      {movies.length === 0 ? (
        <EmptyState title="暂无内容" description="该分类下暂时没有可展示的影视资源" />
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {movies.map((movie) => (
            <MovieCard
              key={movie.id}
              movie={movie}
              className="animate-fade-up"
            />
          ))}
        </div>
      )}
    </section>
  );
}